module.exports = __webpack_public_path__ + "img/aluminium.fb3bbc01.jpg";